module.exports = __webpack_public_path__ + "assets/arrows-vertical.bdd88766.svg";